import { render, staticRenderFns } from "./pic&video.vue?vue&type=template&id=7fa57473&scoped=true&"
import script from "./pic&video.vue?vue&type=script&lang=js&"
export * from "./pic&video.vue?vue&type=script&lang=js&"
import style0 from "./pic&video.vue?vue&type=style&index=0&id=7fa57473&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa57473",
  null
  
)

export default component.exports